import styled from 'styled-components'
import Box from 'components/shared/Box'
import { Color } from 'styles/types'

interface WrapperProps {
    background: Color
}

export const Wrapper = styled(Box)<WrapperProps>`
    background-color: ${({ theme, background }) => theme.colors[background]};
    padding: 16px;
    border-radius: 8px;
`
